import React, {useState} from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";

import { MessageBox } from "../../../common/messagebox";
import { commonErr } from "../../../common/errors";
import { CarTransmission, CarFuel, renderNumberGreaterThan100 } from "../../../common/common";
import {
	IcShareLink,
	SeatCar,
	FuelCar,
	FuelCCar,
	TransCar,
    IcCheckGreen,
    IcCloseRed,
	IcCheckLine,
	IcFuelCS,
	IcCSPolicyCar,
	IcCSPolicyRepair,
	IcCSPolicyLimit
} from "../../../common/svg";

import cmnd from "../../../../static/images/carsubs/cardetailcs/paper/cmnd.png"
import driver from "../../../../static/images/carsubs/cardetailcs/paper/driver.png"
import legal from "../../../../static/images/carsubs/cardetailcs/paper/legal.png"
import list from "../../../../static/images/carsubs/cardetailcs/paper/list.png"


export const InfoCS = ({ info }) => {
	const [copied, setCopied] = useState(false);

	const toggleCopyBox = () => {
		setCopied(!copied);
	};

	return (
		<div className="info-car-basic">
			<div className="group-name">
				  <h3>{info.name}</h3>
			
            <div className="shared">
                <CopyToClipboard text={window.location.href} onCopy={toggleCopyBox}>
                    <div className="wrap-svg wrap-ic share">
                        <IcShareLink />
                    </div>
                </CopyToClipboard>
            </div>
			
			</div>

			<MessageBox error={commonErr.SUCCESS} show={copied} hideModal={toggleCopyBox} message="Đã sao chép liên kết" />
		</div>
	);
};

export const OutsFeatures = ({ info, vehicleName }) => {
	return (
		<div className="info-car-desc" id="outsfeatures">
			<h6>Đặc điểm</h6>
			<div className="outstanding-features">
				<div className="outstanding-features__item">
					<div className="wrap-svg">
						<SeatCar />
					</div>
					<div className="title">
						<p className="sub">Loại xe</p>
						<p className="main">{vehicleName}</p>
					</div>
				</div>
				<div className="outstanding-features__item">
					<div className="wrap-svg">
						<TransCar />
					</div>
					<div className="title">
						<p className="sub">Truyền động</p>
						<p className="main">{CarTransmission[info.transmission]}</p>
					</div>
				</div>
				<div className="outstanding-features__item">
					<div className="wrap-svg">
						<FuelCar />
					</div>
					<div className="title">
						<p className="sub">Nhiên liệu</p>
						<p className="main">{CarFuel[info.fuel]}</p>
					</div>
				</div>
				{info.optionsFuelConsumption > 0 && (
					<div className="outstanding-features__item">
						<div className="wrap-svg">
							<FuelCCar />
						</div>
						<div className="title">
							<p className="sub">NL tiêu hao</p>
							<p className="main">
								{info.optionsFuelConsumption} {info.optionsFuel == 3 ? "km /lần sạc" : "lít/100km"}
							</p>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export const AdvantageCS = () => {
    return (
        <div className="info-car-desc">
        <h6>Ưu điểm của thuê xe dài hạn</h6>
        {/* <div className="col3-mg15 advantage-box">
        <div className="col3-mg15 advantage-inner">
          <div className="item item-inner"> 
          <img src={adv_1} alt="" />
            <p>Thủ tục đơn giản</p>
          </div>
          <div className="item item-inner">
            <img src={adv_2} alt="" />
            <p>Không tốn phí bảo hiểm, phí đường bộ và phí bảo dưỡng xe</p>
          </div>
          <div className="item item-inner"> 
            <img src={adv_3} alt="" />
            <p>Dịch vụ giao xe và bảo dưỡng tận nhà miễn phí</p>
          </div>
          <div className="item item-inner">
            <img src={adv_4} alt="" />
            <p>Không lo xe bị mất giá hằng năm</p>
          </div>
          <div className="item item-inner"> 
            <img src={adv_5} alt="" />
            <p>Không cần đi vay, không lo áp lực trả lãi</p>
          </div>
          <div className="item item-inner"> 
            <img src={adv_6} alt="" />
            <p>Linh động thời gian, sử dụng theo nhu cầu</p>
          </div>
          <div className="item item-inner"> 
            <img src={adv_7} alt="" />
            <p>Trải nghiệm nhiều dòng xe khác nhau theo ý muốn</p>
          </div>
      </div>
      </div> */}
        <div className="cancel-policy">
          <div className="column title"> 
            <div className="column__item">Ưu điểm</div>
            <div className="column__item">Thuê xe dài hạn</div>
            <div className="column__item">Mua xe</div>
          </div>
          <div className="column">
            <div className="column__item">Thủ tục đơn giản</div>
            <div className="column__item">
              <div className="wrap-svg">
                <IcCheckGreen />
              </div>
            </div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCloseRed />
              </div>
            </div>
          </div>
          <div className="column">
            <div className="column__item">Không tốn phí bảo hiểm, <br />phí đường bộ, bảo dưỡng xe</div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCheckGreen />
              </div>
            </div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCloseRed />
              </div>
            </div>
          </div>
          <div className="column">
            <div className="column__item">Dịch vụ giao xe <br />và bảo dưỡng tận nhà miễn phí</div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCheckGreen />
              </div>
            </div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCloseRed />
              </div>
            </div>
          </div>
          <div className="column">
            <div className="column__item">Không lo xe bị mất giá hằng năm</div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCheckGreen />
              </div>
            </div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCloseRed />
              </div>
            </div>
          </div>
          <div className="column">
            <div className="column__item">Không cần đi vay, <br />không lo áp lực trả lãi</div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCheckGreen />
              </div>
            </div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCloseRed />
              </div>
            </div>
          </div>
          <div className="column">
            <div className="column__item">Linh động thời gian, <br />sử dụng theo nhu cầu</div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCheckGreen />
              </div>
            </div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCloseRed />
              </div>
            </div>
          </div>
          <div className="column">
            <div className="column__item">Trải nghiệm nhiều <br />dòng xe khách nhau theo ý muốn</div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCheckGreen />
              </div>
            </div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCloseRed />
              </div>
            </div>
          </div>
          <div className="column">
            <div className="column__item">Dịch vụ tận nhà</div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCheckGreen />
              </div>
            </div>
            <div className="column__item"> 
              <div className="wrap-svg">
                <IcCloseRed />
              </div>
            </div>
          </div>
         
        </div>
      </div>
    )
}

export const PaperCS = () => {
	return (
		<div className="info-car-desc">
			<h6 className="df-align-center">Thủ tục & giấy tờ</h6>
			<div className="required-papers"> 
			
				<div className="required-papers__item">
					<div className="type__item"> 
						<p className="fontWeight-8">Tổ chức</p>
					</div>
					<div className="type-content"> <img src={legal} alt="" />
						<div className="type-name"> 
						<p>Giấy phép kinh doanh</p>
						<p className="note font-14">Đối chiều</p>
						</div>
					</div>
					<div className="type-content"> <img src={driver} alt="" />
						<div className="type-name"> 
						<p>Giấy ủy quyền</p>
						<p className="note font-14">Đối với trường hợp người nhận xe không phải là chủ doanh nghiệp</p>
						</div>
					</div>
					<div className="type-content"> <img src={list} alt="" />
						<div className="type-name"> 
						<p>Thẩm định trực tiếp</p>
						<p className="note font-14">Nếu cần thiết</p>
						</div>
					</div>
				</div>
				<div className="required-papers__item">
					<div className="type__item"> 
						<p className="fontWeight-8">Cá nhân</p>
					</div>
					<div className="type-content"> <img src={cmnd} alt="" />
						<div className="type-name"> 
						<p>CMND/CCCD &amp; GPLX</p>
						<p className="note font-14">Đối chiếu</p>
						</div>
					</div>
					<div className="type-content"> <img src={list} alt="" />
						<div className="type-name"> 
						<p>Thẩm định trực tiếp</p>
						<p className="note font-14">Nếu cần thiết</p>
						</div>
					</div>
				</div>
			</div>
		</div>

	)
}

export const Policy = ({info}) => {
	return (
		<div className="info-car-desc">
		{/* <h6>Điều khoản </h6> */}
		<div className="info-inner"> 
			
			<div className="info-box">
				<div className="wrap-svg"> 
					<IcCSPolicyCar />
				</div>
				<p className="fontWeight-8">Bảo hiểm xe &amp; Cứu hộ</p>
				<div className="info-details"> 
					<div className="wrap-svg"> 
						<IcCheckLine />
					</div>
					<p>100% xe có bảo hiểm năm</p>
				</div>
				<div className="info-details"> 
					<div className="wrap-svg"> 
						<IcCheckLine />
					</div>
					<p>Có liên kết hệ thống garage để cứu hộ kịp thời</p>
				</div>
			</div>
			<div className="info-box">
				<div className="wrap-svg"> 
					<IcCSPolicyRepair />
				</div>
				<p className="fontWeight-8">Bảo dưỡng định kỳ</p>
				<div className="info-details"> 
					<div className="wrap-svg"> 
						<IcCheckLine />
					</div>
					<p>5000 km (tính từ lúc nhận xe) hoặc 2 tháng/lần</p>
				</div>
				<div className="info-details"> 
					<div className="wrap-svg"> 
						<IcCheckLine />
					</div>
					<p>Thời gian bảo dưỡng (2-3 ngày)</p>
				</div>
			</div>
			<div className="info-box">
				<div className="wrap-svg"> 
					<IcCSPolicyLimit />
				</div>
				<p className="fontWeight-8">Giới hạn KM</p>
				<div className="info-details"> 
					<div className="wrap-svg"> 
						<IcCheckLine />
					</div>
					<p>{info.additionalPrice.limitKM} km/tháng</p>
				</div>
			</div>
		</div>
	</div>

	)
}